import { ChangeDay, changeyear, ChangeCardsLoading, ChangeDays, ChangeDaysLoading, ChangeEquipamentoCards, ChangeMonth, 
    ListEquipamentos, LogOut, changeModal, ChangeStatus, ListCities, ChangeCity, ChangeCardIcon, ChangeAutoplay } from "../../Redux/Actions"
import { store } from "../../Redux/Store"
import { toast } from "react-toastify";
import config from "../../Config/config.json";
import { EquipamentoRequest, equipamentoRequest } from "./requests.ts"
import { getDataString } from "../../util/Months.js";
import i18n from "../../Config/i18n.js";

export class EquipamentoService {
    constructor(){
        this.EquipamentoRequest = new EquipamentoRequest();
        this.cards = {
            0: [],
            1: [],
        }
        this.initialCard ={
            0: [
                {
                    "Active": false,
                    "type": 0,
                    "focus": true,
                },
                {
                    "Active": false,
                    "type": 0,
                },
                {
                    "Active": false,
                    "type": 0,
                },
                {
                    "Active": false,
                    "type": 0,
                },
                {
                    "Active": false,
                    "type": 0,
                }
            ],
            1:[
                {
                    "Active": false,
                    "type": 1,
                },
                {
                    "Active": false,
                    "type": 1,
                },
                {
                    "Active": false,
                    "type": 1,
                },
                {
                    "Active": false,
                    "type": 1,
                },
                {
                    "Active": false,
                    "type": 1,
                },
                {
                    "Active": false,
                    "type": 1,
                },
            ]
        }
        this.equipamentosList = [];
        this.equipamento = '';
        this.cardtochange = null;
        this.tempposition = -1;
    }

    // Inicia a os Cards e carrega os dias do primeiro card recebido
    start(equipamento){
        let DataObject = new Date();
        let currentmonth = DataObject.getMonth();
        let data = getDataString(DataObject.getDate());
        store.dispatch(ChangeMonth(getDataString(currentmonth + 1)));
        store.dispatch(changeyear(DataObject.getFullYear()));
        store.dispatch(ChangeDay(data));
    
        data = DataObject.getFullYear() + '-' + getDataString(currentmonth + 1) + '-' + data;
        this.equipamento = equipamento;
        this.loadCards(data);
    }

    // Carrega os cards de acordo com o dia
    async loadCards (data){
        try {
            store.dispatch(ChangeDaysLoading(true));
            store.dispatch(ChangeCardsLoading(true));
            let mewCards = await this.EquipamentoRequest.CardsRequest(this.equipamento, data);
            await this.generateCards(mewCards);
            store.dispatch(ChangeCardsLoading(false));
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            this.cards = this.initialCard;
            store.dispatch(ChangeEquipamentoCards(this.initialCard));
            this.formatDayData({}, 'SD');
            store.dispatch(ChangeCardsLoading(false));
            store.dispatch(ChangeDaysLoading(false));
            return;
        }
    }

    // Gera os cards no formato correto
    async generateCards(newCards){
        if(JSON.parse(localStorage.getItem('AugenCard'+this.equipamento))){
            this.generateOrderCards(newCards);
        }else{
            let Tempcards = {
                0: [],
                1: [],
            };
            newCards.cards.map((card, index) => {
                card.Active = true
                if(index < 5){
                    Tempcards[0].push(card);
                }else{
                    Tempcards[1].push(card);
                }
                return card;
            });
            while (Tempcards[0].length < 5) {
                Tempcards[0].push({
                    Active: false,
                    type: 0,
                });
            }    
            Tempcards[0][0].focus = true;
            if(Tempcards[0][0].id){
                this.getDayData(Tempcards[0][0].id, Tempcards[0][0].key, Tempcards[0][0].name, Tempcards[0][0].idEquipment);
                store.dispatch(ChangeStatus(Tempcards[0][0].status));
            }
            this.cards = Tempcards;
            try {
                localStorage.setItem('AugenCard'+this.equipamento, JSON.stringify(Tempcards));
            } catch (error) {
                
            }
            if(this.search){
                Tempcards = this.FilterCards(this.search);
            }
            store.dispatch(ChangeEquipamentoCards(JSON.parse(JSON.stringify(Tempcards)), Tempcards[0][0].name));
        }
    }

    // Altera o card que está em foco
    changeFocus(cardid, indice, key, idEquipment){
        try {
            let newIndex = 0;
            let focusCard;
            let oldCard;
            let status = 0;
            this.cards[0].map((card, index) => {
                if(card.id === cardid && card.key === key && card.idEquipment === idEquipment){
                    focusCard = card;
                    card.focus = true;
                    status = card.status;
                }else if(card.focus === true){
                    newIndex = index;
                    oldCard = card;
                    card.focus = false;
                }
                return card;
            })
            this.cards[0][newIndex] = focusCard;
            this.cards[0][indice] = oldCard;
            let name = focusCard.name;
            this.getDayData(cardid, key, name, idEquipment);
            store.dispatch(ChangeStatus(status));
            if(this.search){
                let Tempcards = this.FilterCards(this.search);
                store.dispatch(ChangeEquipamentoCards(JSON.parse(JSON.stringify(Tempcards)), name));
            }else{
                store.dispatch(ChangeEquipamentoCards(JSON.parse(JSON.stringify(this.cards)), name));
            }
            
            localStorage.setItem('AugenCard'+this.equipamento, JSON.stringify(this.cards));
        } catch (error) {
            console.log(error)
        }
    }

    // Remove card dos favoritos
    removeFAV(position){
        if(this.cards[0].filter(card => card.Active === true).length < 2){
            toast(i18n.t("message.dashboard-service.equipment.remove-fav"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return
        }
        let name;
        let tempcard = this.cards[0][position];

        if(tempcard.focus){
            this.cards[0].splice(position, 1, {
                "Active": false,
                "focus": false
            })

            tempcard.focus = false;
            this.cards[0][0].focus = true;
            name = this.cards[0][0].name;
            this.getDayData(this.cards[0][0].id, this.cards[0][0].key, name, this.cards[0][0].idEquipment);
            store.dispatch(ChangeStatus(this.cards[0][0].status));
        }else{
            this.cards[0].splice(position, 1, {
                "Active": false,
                "focus": false
            })
            let focus = this.cards[0].find(card => card.focus === true);
            name = focus.name;
        }
        this.cards[1].push(tempcard)
        try {
            localStorage.setItem('AugenCard'+this.equipamento, JSON.stringify(this.cards));
        } catch (error) {
            
        }
        if(this.search){
            let Tempcards = this.FilterCards(this.search)
            store.dispatch(ChangeEquipamentoCards(JSON.parse(JSON.stringify(Tempcards)), name));
        }else{
            store.dispatch(ChangeEquipamentoCards(JSON.parse(JSON.stringify(this.cards)), name));
        }
    }

    // Adiciona card aos favoritos
    AddFav(id, key){
        let Cards = this.cards[0].filter(card => card.Active === true);
        let focusedCard = Cards.some(card => card.focus === true);
        if(Cards.length < 5){
            let tempcard = this.cards[1].find(card => card.id === id && card.key === key);
            this.cards[1] = this.cards[1].filter(card => card.id !== id || (card.id !== id && card.key !== key));            

            const method = !focusedCard ? 'unshift' : 'push';

            if (!focusedCard) {
                this.getDayData(tempcard.id, tempcard.key, tempcard.name, tempcard.idEquipment);
                store.dispatch(ChangeStatus(tempcard.status));
                tempcard.focus = true;
            }
            Cards[method](tempcard);

            while (Cards.length < 5) {
                Cards.push({
                    Active: false,
                    type: 0,
                });
            }
            let focus = Cards.find(card => card.focus === true);
            let name = focus?.name;
            this.cards[0] = Cards;
            try {
                localStorage.setItem('AugenCard'+this.equipamento, JSON.stringify(this.cards));
            } catch (error) {
                
            }

            if(this.search){
                let Tempcards = this.FilterCards(this.search);
                store.dispatch(ChangeEquipamentoCards(JSON.parse(JSON.stringify(Tempcards)), name));
            }else{
                store.dispatch(ChangeEquipamentoCards(JSON.parse(JSON.stringify(this.cards)), name));
            }
        }else{
            this.cardtochange = this.cards[1].find(card => card.id === id && card.key === key);
            store.dispatch(ChangeAutoplay(false));
            store.dispatch(ChangeCardIcon(true));
        }
    }

    // Altera o card favorito do usuário e abre a modal para escolher o card a ser removido
    putCard(position, type){
        // let newCard = false
        if(this.cards[type][position]?.name){
            this.cardtochange = this.cards[type][position]
            this.tempposition = position
            store.dispatch(changeModal('changeFavCard'));
            // newCard = this.cards[type][position]
        }else{
            toast(i18n.t("message.dashboard-service.equipment.put-card"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        }
    }

    // Altera o card favorito do usuário 
    changeFavCard(position, focus){
        let index = this.cards[1].indexOf(this.cardtochange);
        let currentFocus = this.cards[0].find(card => card.focus === true);
        if(this.cardtochange){
            this.cards[1][this.tempposition] = this.cards[0][position];
            this.cards[1][this.tempposition].focus = false;
            if(focus){
                currentFocus = this.cardtochange;
                this.getDayData(this.cardtochange.id, this.cardtochange.key, this.cardtochange.name, this.cardtochange.idEquipment);
            }
            this.cardtochange.focus = focus;
            this.cards[0][position] = this.cardtochange;
            this.cards[1].splice(index, 1);
            this.cards[1].push(this.cards[1][this.tempposition]);
            store.dispatch(ChangeStatus(this.cardtochange.status));
            if(this.search){
                let Tempcards = this.FilterCards(this.search)
                store.dispatch(ChangeEquipamentoCards(JSON.parse(JSON.stringify(Tempcards)), currentFocus.name));
            }else{
                store.dispatch(ChangeEquipamentoCards(JSON.parse(JSON.stringify(this.cards)), currentFocus.name));
            }
            store.dispatch(ChangeCardIcon(false));
            try {
                localStorage.setItem('AugenCard'+this.equipamento, JSON.stringify(this.cards));
            } catch (error) {
                
            }
        }else{
            toast(i18n.t("message.dashboard-service.equipment.change-fav-card"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        }
    }

    // Pega os dados dos dias
    async getDayData(card, key, name, idEquipment){
        if(card){
            try {
                store.dispatch(ChangeDaysLoading(true));
                let data = store.getState().DashboardEquipamentoReducer.year + '-' + store.getState().DashboardEquipamentoReducer.month + '-' + store.getState().DashboardEquipamentoReducer.day;
                let flag = store.getState().DashboardEquipamentoReducer.Mode;
                let newData = await this.EquipamentoRequest.daysRequest(this.equipamento, data, card, flag, key, idEquipment);
                this.formatDayData(newData, name);
                store.dispatch(ChangeDaysLoading(false));
            } catch (error) {
                console.log(error)
                toast(error.message, {
                    position: "top-center",
                    type: 'error',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: config.theme,
                });
                if(error.status === 401){
                    store.dispatch(LogOut());
                }
                this.formatDayData({}, name);
                store.dispatch(ChangeDaysLoading(false));
                return;
            }
        }
    }

    // Altera o dia
    async changeDay(day, month, year){
        this.ChangeCards(year + '-' + getDataString(month) + '-' + getDataString(day));
        // this.ChangeCards(year + '-' + getDataString(month));
    }

    // Método para alterar o mes/ano
    changeMonthYear(day, month, year){
        this.loadCards(year + '-' + month + '-' + day);
        // this.loadCards(year + '-' + month);
    }

    // Função para buscar os equipamentos do usuário
    async getEquipamentos(){
        try {
            const equipamentosList = await equipamentoRequest.getEquipamentosByUser();
            // let List = [{id: 'geral', nome: 'Dashboard Geral'}];
            let List = [{id: '', nome: i18n.t("select.equipment")}];
            List.push(...equipamentosList.authorized_equipments.equipments);
            List.push(...equipamentosList.authorized_equipments.grouppings);
            this.equipamentosList = List;
            store.dispatch(ListEquipamentos(List))
            if(store.getState().DashboardEquipamentoReducer?.city){
                this.filterEquipaments(store.getState().DashboardEquipamentoReducer.city);
            }
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    async ChangeCards(data){
        try {
            store.dispatch(ChangeCardsLoading(true));
            let mewCards = await this.EquipamentoRequest.CardsRequest(this.equipamento, data);
            await this.generateOrderCards(mewCards, true);
            store.dispatch(ChangeCardsLoading(false));
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            this.formatDayData({}, 'SD');
            store.dispatch(ChangeCardsLoading(false));
            store.dispatch(ChangeDaysLoading(false));
            return;
        }
    }

    // Gera os cards no formato correto
    async generateOrderCards(newCards, changedays){
        // console.log('newcardsDash', newCards)
        let Tempcards = {
            0: [],
            1: [],
        }
        let oldcards = JSON.parse(localStorage.getItem('AugenCard'+this.equipamento));
        // console.log('oldcards', oldcards)
        let name;
        if(oldcards){
            // Verifica se há novos cards
            newCards.cards.map(card => {
                if(!oldcards[1].some(oldcard => oldcard.id === card.id && oldcard.key === card.key) && 
                !oldcards[0].some(oldcard => oldcard.id === card.id && oldcard.key === card.key)){
                    card.Active = true;
                    oldcards[1].push(card);
                }
                return card;
            })
    
            // posiciona os novos cards na posição correta
            oldcards[0].map((card) => {
                let temp = newCards.cards.find(newcard => newcard.id === card.id && newcard.key === card.key)
                if(temp){
                    temp.Active = true;
                    temp.focus = card.focus;
                    if(card.focus){
                        if(!changedays){
                            this.getDayData(temp.id, temp.key, temp.name, temp.idEquipment);
                        }
                        store.dispatch(ChangeStatus(temp.status));
                        name = temp.name;
                    } 
                    Tempcards[0].push(temp);
                }
                return card;
            });
            oldcards[1].map(card => {
                let temp = newCards.cards.find(newcard => newcard.id === card.id && newcard.key === card.key)
                if(temp){
                    temp.Active = true;
                    Tempcards[1].push(temp);
                } 
                return card;
            });
        }else{
            newCards.cards.map((card, index) => {
                card.Active = true
                if(index < 5){
                    Tempcards[0].push(card);
                }else{
                    Tempcards[1].push(card);
                }
                return card;
            });
        }

        // Completa a lista de cards
        while(Tempcards[0].length < 5){
            if(Tempcards[1].length > 0){
                Tempcards[0].push(Tempcards[1][0]);
                Tempcards[1].splice(0, 1);
            }else{
                Tempcards[0].push({
                    "Active": false,
                    "type": 0,
                });
            }
        }

        // Verifica se o card que está em foco ainda existe
        if(!name){
            Tempcards[0][0].focus = true;
            name = Tempcards[0][0].name;
            this.getDayData(Tempcards[0][0].id, Tempcards[0][0].key, Tempcards[0][0].name, Tempcards[0][0].idEquipment);
            store.dispatch(ChangeStatus(Tempcards[0][0].status));
        }

        this.cards = Tempcards;
        if(this.search){
            Tempcards = this.FilterCards(this.search);
        }
        store.dispatch(ChangeEquipamentoCards(JSON.parse(JSON.stringify(Tempcards)), name));
        try {
            localStorage.setItem('AugenCard' + this.equipamento, JSON.stringify(Tempcards));
        } catch (error) {
            
        }
        setTimeout(() => {
            store.dispatch(ChangeCardsLoading(false));
        }, 5);
    }

    // Busca o arquivo na api
    async getExcel(id, datainicio, datafim, analysisMode, readingMode, methodOld, extension){
        store.dispatch(changeModal('download'));
        setTimeout(async () => {
            store.dispatch(changeModal(''));
            try {
                let data1 = this.formatarDataParaYMDHMS(datainicio);
                let data2 = this.formatarDataParaYMDHMS(datafim);
                toast(i18n.t("message.dashboard-service.equipment.get-excel"), {
                    position: "top-center",
                    type: 'info',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                });

                const excel = await equipamentoRequest.getExcel(id, data1, data2, analysisMode, readingMode, methodOld, extension);
                if (excel?.data?.type === 'application/json') {
                    const text = await excel.data.text();
                    const json = JSON.parse(text);
                    toast(json.message, {
                        position: "top-center",
                        type: 'info',
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                    });
                } else {

                    let equipamentName = this.equipamentosList.find(equipamento => equipamento.id === id).nome;
                    await this.createFile(excel, datainicio, datafim, equipamentName, extension);
                }
            } catch (error) {
                console.log(error)
                toast(error.message, {
                    position: "top-center",
                    type: 'error',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                });
                if(error.status === 401){
                    store.dispatch(LogOut());
                }
            }

        }, "2500");
    }

    // Formatar a data
    formatarDataParaYMDHMS(time) {
        let data = new Date(time);
        const year = data.getFullYear();
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        const seconds = String(data.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    // Formatar a data
    formatarDataParaDMHM(time) {
        let data = new Date(time);
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        
        return `${day}-${month} ${hours}h${minutes}m`;
    }

    // Criar o arquivo para download
    async createFile (data, data1, data2, equipamentName, fileFormat){
        const url = window.URL.createObjectURL(data);
        let name = this.formatarDataParaDMHM(data1)+' até '+ this.formatarDataParaDMHM(data2)
      
        const link = document.createElement('a');
        link.href = url;
        link.download =  `${equipamentName + ' ' + name}.${fileFormat}`;
        link.click();
      
        // Liberar o URL do Blob após o download
        window.URL.revokeObjectURL(url);
    }

    // Formata os dados para o gráfico dos dias
    formatDayData(dados, name){
        let values = Object.values(dados);
        let datas = Object.keys(dados);
        let temp = values.map((valor, index) => {
            let hoje = new Date();
            return{
                y: valor,
                x: datas[index].length < 3 ? new Date(hoje.setHours(datas[index])) : new Date(datas[index])
            }
        })
        let data ={
            "id": name ? name : store.getState().DashboardEquipamentoReducer.name,
            "data": temp
        }
        let newdata = [];
        data.data.sort((a, b) => a.x - b.x);
        newdata.push(data);
        store.dispatch(ChangeDays(newdata));
    }

    // Refaz o request para as hora (funciona para dias tbm)
    async getHoursData(){
        let focusCard;
        this.cards[0].map(card => {
            if(card.focus){
                focusCard = card
            }
            return card;
        })
        if(focusCard.id){
            try {
                store.dispatch(ChangeDaysLoading(true));
                let data = store.getState().DashboardEquipamentoReducer.year + '-' + store.getState().DashboardEquipamentoReducer.month + '-' + store.getState().DashboardEquipamentoReducer.day;
                let flag = store.getState().DashboardEquipamentoReducer.Mode;
                let newData = await this.EquipamentoRequest.daysRequest(this.equipamento, data, focusCard.id, flag, focusCard.key, focusCard.idEquipment);
                this.formatDayData(newData, focusCard.name);
                store.dispatch(ChangeDaysLoading(false));
            } catch (error) {
                console.log(error)
                toast(error.message, {
                    position: "top-center",
                    type: 'error',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: config.theme,
                });
                if(error.status === 401){
                    store.dispatch(LogOut());
                }
                this.formatDayData({}, focusCard.name);
                store.dispatch(ChangeDaysLoading(false));
                return;
            }
        }
    }

    async getReport(id, datainicio, datafim){
        store.dispatch(changeModal('report'));
        try {
            let data1 = this.formatarDataParaYMDHMS(datainicio);
            let data2 = this.formatarDataParaYMDHMS(datafim);
            await equipamentoRequest.getReport(id, data1, data2);
            // toast(i18n.t("message.dashboard-service.equipment.get-report"), {
            //     position: "top-center",
            //     type: 'info',
            //     autoClose: 3000,
            //     hideProgressBar: false,
            //     closeOnClick: true,
            //     pauseOnHover: false,
            //     draggable: false,
            //     progress: undefined,
            // });
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    async getCities(){
        try {
            let cities = await equipamentoRequest.RequestCities();
            cities.authorized_cities.forEach(obj => {
                obj.id = obj.code_ibge;
                obj.nome = obj.name;
                delete obj.name;
                delete obj.code_ibge;
            })
            let list = [{id: '', nome: i18n.t("select.city")}];
            list.push(...cities.authorized_cities);
            store.dispatch(ListCities(list));
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    filterEquipaments(city){
        if(city){
            store.dispatch(ChangeCardsLoading(true));
            store.dispatch(ChangeDaysLoading(true));
            let newList = this.equipamentosList.filter(equipament => parseInt(equipament.city_code) === parseInt(city) || equipament.city_code === undefined);
            store.dispatch(ChangeCity(city));
            store.dispatch(ListEquipamentos(newList));
        }else{
            store.dispatch(ChangeCity(city));
            store.dispatch(ListEquipamentos(this.equipamentosList));
        }
    }

    changeCity(equipamento){
        try {
            let currentCity = this.equipamentosList.find(equip => equip.id === equipamento);
            let newList = this.equipamentosList.filter(equipament => parseInt(equipament.city_code) === parseInt(currentCity.city.code_ibge) || equipament.city_code === undefined);
            if(currentCity.city){
                store.dispatch(ListEquipamentos(newList));
                store.dispatch(ChangeCity(currentCity.city.code_ibge));
                return currentCity.city.code_ibge;
            }else{
                store.dispatch(ChangeCity(''));
                return '';
            }
        } catch (error) {
            setTimeout(() => {
                this.changeCity(equipamento);
            }, 2000);
            console.log(error)
        }
    }

    FilterCards(search){
        this.search = search;
        let newCards = {
            0: [],
            1: [],
        }
        newCards[0] = this.cards[0]
        this.cards[1].map(card => {
            console.log(card.name, "filtro geral")//acessando de forma incorreta
            if(card.name.toLowerCase().includes(search.toLowerCase())){
                newCards[1].push(card);
            }
            return card;
        })
        this.filteredCards = newCards[0];
        let name = this.cards[0].find(card => card.focus === true).name;
        store.dispatch(ChangeEquipamentoCards(JSON.parse(JSON.stringify(newCards)), name));
        return JSON.parse(JSON.stringify(newCards));
    }
}